var exports = {
  "fs": "SpaceBackground.module__starfield___MXFwcX",
  "UB": "SpaceBackground.module__starDrift___MXFwcX",
  "hi": "SpaceBackground.module__spaceBackground___MXFwcX" + " " + "SpaceBackground.module__starfield___MXFwcX",
};

module.exports = exports;
